import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: Events
 *
 * Displays a list of events associated with an action path.
 *
 * @param assets
 * @param data
 * @returns {Element}
 * @constructor
 */
export function Events({ assets, data }) {
  const events = data?.ListEvents?.data?.content;

  return (
    <ErrorHandler location="src/widgets/RiskRecords/Events/Events.jsx">
      <Grid>
        <Grid.Col
          span={{
            xs: '100%',
          }}
        >
          {!isUndefined(events) && !isEmpty(events) ? (
            <Table assets={assets} rows={events} />
          ) : (
            <Alert title="No events found in date range." variant="info" />
          )}
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
